import { ImagePreviewButtonComponent } from '@aipb/gulliver/catalog/feature-image-preview';
import { MultiImageDownloadCheckboxComponent } from '@aipb/gulliver/catalog/feature-multi-image-download';
import { CustomRecordItem } from '@aipb/gulliver/catalog/model';
import { createDetailCompositeKey } from '@aipb/gulliver/catalog/util';
import { AddToFavoritesButtonComponent } from '@aipb/gulliver/personal-content/feature-favorite-button';
import { AddToFavoritesButtonConfig } from '@aipb/gulliver/personal-content/model';
import { InsideLoadingComponent } from '@aipb/shared/ui/loading';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { ResultListItemBase } from '../result-list-item.base';
import { SafePipe } from '@aipb/shared/ui/pipes';
import { LightboxButtonComponent } from '@aipb/gulliver/catalog/feature-lightbox';

@Component({
  selector: 'cat-result-list-tile-simple-item',
  templateUrl: './result-list-tile-simple-item.component.html',
  styleUrls: ['./result-list-tile-simple-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    AddToFavoritesButtonComponent,
    ImagePreviewButtonComponent,
    MultiImageDownloadCheckboxComponent,
    InsideLoadingComponent,
    SafePipe,
    LightboxButtonComponent
  ]
})
export class ResultListTileSimpleItemComponent extends ResultListItemBase {
  @Input() loading: boolean;

  private cdr = inject(ChangeDetectorRef);

  get addToFavoritesButtonConfig(): AddToFavoritesButtonConfig {
    const params: AddToFavoritesButtonConfig = {
      type: this.isDropbox(this.item) ? 'RECDBOX' : 'REC',
      service: this.catalogEnv.env.service,
      serviceValue: createDetailCompositeKey(this.coreId, this.item.header.id)
    };

    if (this.isDropbox(this.item)) {
      params['serviceLabel'] = this.item.header.label.value;
      params['serviceThumb'] = this.getThumb(this.item);
    } else {
      params['userLabel'] = this.item.header.label.value;
      params['userThumb'] = this.getThumb(this.item);
    }

    return params;
  }

  onAfterAddToFavorites() {
    this.cdr.detectChanges();
  }

  getThumb(item: CustomRecordItem): string {
    let thumb = 'https://en.wikipedia.org/static/images/project-logos/enwiki-1.5x.png';

    if (item.header.images.length > 0) {
      thumb = item.header.images[0].thumb;
    }
    return thumb;
  }

  removeHighlight(s: string) {
    return s.replace(/(<em>)(.+?)(<\/em>)/g, '$2');
  }
}
